import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Sticky from 'react-stickynode';
import get from 'lodash/get';
import assign from 'lodash/assign';
import chunk from 'lodash/chunk';
import isEmpty from 'lodash/isEmpty';
import striptags from 'striptags';
import Card from '../card/card';
import Ad from '../ad/ad';
import Slug from '../slug/slug';
import getSiteFromURI from '../../../utils/get_site_from_uri_util';
import { imageSizesLookup } from '../../../utils/cloudinary_asset_util';
import matchMediaDesktop from '../../../utils/client_util';

class AllFeed extends Component {
  // eslint-disable-next-line react/prefer-stateless-function
  constructor(props) {
    super();
    this.allStories = props.stories;
    this.adModel = props.adModel;
  }

  componentDidMount() {
    this.isDesktop = matchMediaDesktop();
  }

  getAllStories() {
    const formattedStories = this.allStories.map((post, i) =>
      assign(post, {
        currentSite: get(this.props, 'site'),
        site: getSiteFromURI(get(post, 'link')),
        assetSizes: i === 0
          ? imageSizesLookup.bigFirstMobile
          : imageSizesLookup[3],
        env: get(this.props, 'env'),
        allowNoImage: true,
        excerpt: striptags(post.excerpt || '')
      })
    );

    if (this.props.allRendered) {
      return formattedStories;
    }

    return this.allStories.length >= 10
      ? formattedStories.slice(0, 10)
      : formattedStories;
  }

  getSections() {
    const sections = chunk(this.getAllStories(), 5);

    return sections.map((section, index) => ({
      id: `section-${index + 1}`,
      stories: section
    }));
  }

  renderMoreButton(index) {
    if (index !== 1 || this.props.allRendered || this.props.disableMore) {
      return null;
    }

    return (
      <div
        className={`all-feed__button all-feed__button--${get(
          this.props,
          'site'
        )} ${this.props.mobileSeeMoreHidden
          ? 'all-feed__button--mobile-hidden'
          : ''}`}
      >
        <button onClick={this.props.setAllLoadedState}>See More Stories</button>
      </div>
    );
  }

  renderMobileAd(index) {
    if (index === 1) {
      return null;
    }

    return (
      <div className="all-feed__mobile-ad-container">
        <Ad {...this.adModel} name="mobilerectangle_3" />
      </div>
    );
  }

  renderSlugOrName(props) {
    if (!props || !props.hasSlug) {
      return null;
    }

    if (props.authorPage) {
      if (isEmpty(props.author)) return '';

      return (
        <h2 className="author-page__all-feed-title">
          {`Stories by ${get(props.author, 'name')}`}
          <span className="author-page__all-feed-title-rss">
            <a href={`/user/${get(props.author, 'slug')}/rss`}>RSS</a>
          </span>
        </h2>
      );
    }

    if (!isEmpty(props.advertorialSlugs)) {
      return (
        <Slug
          slugName={get(props.advertorialSlugs, 'name')}
          className="tag-page"
          advertorial={true}
        />
      );
    }

    return (
      <Slug
        linkTo="//www.fastcompany.com"
        slugName={get(props, 'titleOverride') || 'All Stories'}
      />
    );
  }

  render() {
    const {
      advertorialSlugs,
      authorPage,
      author,
      hasSlug,
      titleOverride
    } = this.props;
    let modifier = this.props.modifier;

    if (!modifier && !hasSlug) {
      modifier = 'no-slug';
    }

    const fullPageAdvertorial = modifier === 'advertorial';

    const allFeedLength = get(this.props, 'stories').length;

    return (
      <section className="all-feed">
        {this.renderSlugOrName({
          advertorialSlugs,
          authorPage,
          author,
          hasSlug,
          titleOverride
        })}

        <div
          className={`all-feed__wrapper ${modifier
            ? `all-feed__wrapper--${modifier}`
            : ''}`}
        >
          {this.getSections().map((section, index) => {
            const adCounter = index + 1;

            return (
              <div key={section.id} className="all-feed__section">
                <div className="all-feed__posts">
                  {section.stories.map(story =>
                    <Card
                      className="all-feed"
                      key={story.id}
                      metadata={story}
                      env={story.env}
                      hasExcerpt={true}
                      fullPageAdvertorial={fullPageAdvertorial}
                    />
                  )}
                  {this.renderMobileAd(index)}
                  {allFeedLength > 10 ? this.renderMoreButton(index) : ''}
                </div>

                <div className="all-feed__sidebar">
                  <div
                    className="all-feed__promotion"
                    id={`sidebar-ad-${index}`}
                  >
                    <Sticky
                      top={100}
                      bottomBoundary={`#sidebar-ad-${index}`}
                      enabled={this.isDesktop}
                    >
                      <Ad
                        {...this.adModel}
                        name={`flexiblehalfpage_${adCounter}`}
                      />
                    </Sticky>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    );
  }
}

AllFeed.defaultProps = {
  stories: [],
  allRendered: false,
  modifier: '',
  mobileSeeMoreHidden: false,
  advertorialSlugs: {},
  authorPage: false,
  author: {},
  hasSlug: true,
  search: false,
  disableMore: false,
  titleOverride: ''
};

AllFeed.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.shape({})),
  adModel: PropTypes.shape({}).isRequired,
  allRendered: PropTypes.bool,
  setAllLoadedState: PropTypes.func.isRequired,
  modifier: PropTypes.string,
  mobileSeeMoreHidden: PropTypes.bool,
  advertorialSlugs: PropTypes.shape({}),
  authorPage: PropTypes.bool,
  author: PropTypes.shape({}),
  hasSlug: PropTypes.bool,
  disableMore: PropTypes.bool,
  titleOverride: PropTypes.string
};

function mapStateToProps(state = {}) {
  return {
    site: state.config.site
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    setAllLoadedState() {
      dispatch(ownProps.updateAction());
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AllFeed);



// WEBPACK FOOTER //
// ./src/views/components/all_feed/all_feed.js